import { render, staticRenderFns } from "./BarBasic.vue?vue&type=template&id=2f6c9454&scoped=true&"
import script from "./BarBasic.vue?vue&type=script&lang=js&"
export * from "./BarBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c9454",
  null
  
)

export default component.exports